import {Divider} from "@mui/material"
import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
export const BannerInnerContainer = styled("div")`
    display: flex;
    align-items: center;
    margin-left: auto;
    max-width: ${breakpoints.values.xl}px;
    justify-content: end;
    margin: 0 0.5rem 0 1rem;

    @media (min-width: ${breakpoints.values.md}px) {
        padding: 0rem 2.125rem;
        margin: 0;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        margin-right: 0.5rem;
    }
`

export const CountrySelectContainer = styled("span")`
    display: flex;
`

export const StyledDivider = styled(Divider)`
    margin-left: 0.938rem;
    margin-right: 0.25rem;
    border-color: ${({theme}) => theme.uxfabric.components.appBar.globalBar.default.divider.default.borderColor};
`
